import store from "@/store";
import translateField from "@/plugins/translate-field";

export function showValidateError(errorObject: any) {
  let errors = errorObject.violations;
  let _error: any = [];
  errors.forEach((element: any) => {
    let errorAsString = `${translateField(element.propertyPath)}: ${
      element.title
    }`;
    _error.push(errorAsString);
  });
  return _error.join(", ");
}
